import {PortableText} from '@portabletext/react';
import {Image} from '@shopify/hydrogen';

export default function BlockComponent({body}) {
  let textHTML = '';
  let totalIndex = 0;
  body.map((item, index) => {
    if (item.children) {
      item.children.map(({text}) => {
        textHTML += text;
      });
      totalIndex = index;
    }
  });

  const gridCols = textHTML.length > 1000 ? 2 : 1;
  const components = {
    types: {
      image: ({value}) => <img src={value.asset.url} alt={value.asset.altText}  />,
      callToAction: ({value, isInline}) =>
        isInline ? (
          <a href={value.url}>{value.text}</a>
        ) : (
          <div>{value.text}</div>
        ),
    },
    list: {
      // Ex. 1: customizing common list types
      bullet: ({children}) => <ul className="mt-xl">{children}</ul>,
      number: ({children}) => <ol className="mt-lg">{children}</ol>,

      // Ex. 2: rendering custom lists
      checkmarks: ({children}) => (
        <ol className="m-auto text-lg">{children}</ol>
      ),
    },
    listItem: {
      // Ex. 1: customizing common list types
      bullet: ({children}) => (
        <li>{children}</li>
      ),
      number: ({children}) =>  <li>{children}</li>,
      // Ex. 2: rendering custom list items
      checkmarks: ({children}) => <li>✅ {children}</li>,
    },
  };
  return (
    <>
      <div className={`librero-block gap-8 xs:grid-cols-1`}>
        <PortableText value={body} components={components} />
      </div>
    </>
  );
}
